import FileSaver from 'file-saver';
import moment from 'moment-timezone';

export const exportRawData = (
  fileName: string,
  metadata: Array<string>,
  data: any,
  unit: string
) => {
  const headers = ['ID', 'DataTs', 'DateTime(SGT)', 'Value', 'QcFlag', 'Unit'];
  const rows = [
    ...metadata.map((md: any) => [md]),
    headers,
    ...data.map((obj: any) => [
      obj.dataId,
      `#${obj.timestamp}`,
      moment
        .utc(Number(obj.timestamp))
        .tz('Asia/Singapore')
        .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      obj.qcValue,
      obj.qcFlag,
      unit
    ])
  ];

  let csvContent = new File(
    [rows.map((e) => e.join(',')).join('\r\n')],
    fileName + '.csv',
    {
      type: 'text/csv;charset=utf-8'
    }
  );
  FileSaver.saveAs(csvContent);
};
